import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Checkbox } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {
  DeleteOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notification from 'components/theme_components/Notifications';
import { AuthContext } from 'components/Auth/Auth';
import { TpAuthorizationResponse } from 'services/thirdParty';
import IBasket from 'icons/IBasket';
export type ActivityModalProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  dataInput: any;
  loading: boolean

};

const TabDeleteSiloInter = ({ form, onDone, onCancel, dataInput, loading }: ActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);

  const [ischeked, setIschecked] = useState<boolean>(false);

  useEffect(() => {
    if (dataInput) {
      form.setFieldsValue({
        siloid: dataInput.siloid,
        event: 'TabDeleteSiloInter',
      })
    }
  }, [dataInput])




  const validateFields = () => {
    form.validateFields().then(() => {
      onDone();

    })
  }



  return (
    <div className='ut-delete-activity-checkbox mt-4'>
      <FormInput
        col
        xs={24}
        lg={24}
        name="flagdeletesilo"
        valuePropName="checked"
        noStyle
        rules={[{ required: true }]}
      >
        <Checkbox onChange={(e) => {
          setIschecked(e.target.checked);
        }}>
          <span>
            <GetLabel label="flagdeletesilo" />
          </span>
        </Checkbox>
      </FormInput>
      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => !isInspect && onCancel()}
        />
        <ButtonLink
          type="primary"
          comcode="Supprimer"
          htmlType="submit"
          className={ischeked ? 'ut-reset-btn ml-0 ut-btn-delete' : 'ut-reset-btn ml-0 ut-btn-disabled'}
          icon={<DeleteOutlined />}
          onClick={() => {
            !isInspect && validateFields()

          }}
          loading={loading}
          iconPosition="end"
          disabled={!ischeked}
        />
      </Row>
    </div>
  );
};

export default TabDeleteSiloInter;
